import {
  createTranslationRef,
  createTranslationResource,
} from '@backstage/frontend-plugin-api';

export const appTranslationRef = createTranslationRef({
  id: 'app',
  messages: {
    navigation: {
      search: 'Search',
      menu: 'Menu',
      settings: 'Settings',
      home: 'Home',
      catalog: 'Catalog',
      create: 'Create',
      databaseCredentials: 'MySQL Credentials',
      catalogGraph: 'Catalog Graph',
      registerExisting: 'Register Existing',
      visualizer: 'Visualizer',
    },
    signInPage: {
      githubMessage: 'Sign in using your GitHub account',
    },
    databaseCredentials: {
      applicationName: 'Application name',
      clearNotice: 'Credentials are cleared automatically after one minute.',
      copy: 'Copy',
      database: 'Database',
      description:
        'Reveal the current MySQL credentials for an application you own.',
      error: 'Unable to reveal database credentials.',
      headerLabel: 'Database',
      hide: 'Hide credentials',
      host: 'Host',
      notRequired: 'Not required',
      password: 'Password',
      phpExample: 'PHP example',
      phpPrerequisite: 'Requires the PHP pdo_mysql extension.',
      port: 'Port',
      pythonExample: 'Python example',
      pythonPrerequisite:
        'Requires mysql-connector-python (install with: uv add mysql-connector-python).',
      required: 'Required',
      reveal: 'Reveal credentials',
      title: 'MySQL Credentials',
      tls: 'TLS',
      username: 'Username',
      sslCaDescription:
        'The platform injects MySQL connection variables into the application container. These examples read them and use MYSQL_SSL_CA to validate TLS.',
    },
  },
});

export const appTranslationResource = createTranslationResource({
  ref: appTranslationRef,
  translations: {
    'pt-BR': () => import('./app.pt-BR'),
  },
});
